import _ from 'lodash'

export function formatAndFilterAccommodations(accommodations, destination) {
  return _.reduce(accommodations, (accommodationList, accommodation) => {
    if (
      _.get(accommodation, 'destination.id') === destination
      && _.get(accommodation, 'featured')
    ) {
      return _.concat(accommodationList, [{
        ..._.omit(accommodation, ['@id', '@type', 'brand', 'featured']),
        images: _.has(accommodation, 'viewExtensions.images')
          ? _.get(accommodation, 'viewExtensions.images')
          : _.isEmpty(_.get(accommodation, 'images'))
          ? _.get(accommodation, 'defaultImage', [])
          : _.get(accommodation, 'images'),
        name: _.replace(_.get(accommodation, 'name'), '&amp;', '&'),
        ...(_.get(accommodation, 'address.addressLine[0]') && {address: _.get(accommodation, 'address.addressLine[0]')}),
      }])
    }
    return accommodationList
  }, [])
}